import React from 'react';
import { ButtonSelect, Flex } from '@upsales/components';
import T from 'Components/Helpers/translate';
import type { ActiveFilter, ProductTypeFilter, RecurringFilter } from 'Store/reducers/AdminProductListReducer';

type Props = {
	activeFilter: ActiveFilter;
	onActiveFilterChange: (value: ActiveFilter) => void;
	productTypeFilter: ProductTypeFilter;
	onProductTypeFilterChange: (value: ProductTypeFilter) => void;
	recurringFilter: RecurringFilter;
	onRecurringFilterChange: (value: RecurringFilter) => void;
};

const ProductListFilters = ({
	activeFilter,
	onActiveFilterChange,
	productTypeFilter,
	onProductTypeFilterChange,
	recurringFilter,
	onRecurringFilterChange
}: Props) => {
	const hasProductBundle = Tools.FeatureHelper.isAvailable(Tools.FeatureHelper.Feature.PRODUCT_BUNDLES);
	const hasRecurringOrder = Tools.FeatureHelper.isAvailable(Tools.FeatureHelper.Feature.RECURRING_ORDER);

	return (
		<Flex className="admin-products-filters" gap="16px" alignItems="center">
			{hasProductBundle ? (
				<ButtonSelect
					size="sm"
					value={productTypeFilter}
					options={[
						{ value: 'all' as const, title: T('default.all') },
						{ value: 'products' as const, title: T('default.products') },
						{ value: 'bundles' as const, title: T('admin.products.bundles') }
					]}
					onChange={onProductTypeFilterChange}
				/>
			) : null}
			{hasRecurringOrder ? (
				<ButtonSelect
					size="sm"
					value={recurringFilter}
					options={[
						{ value: 'all' as const, title: T('default.all') },
						{ value: 'oneoff' as const, title: T('admin.products.oneOff') },
						{ value: 'recurring' as const, title: T('admin.products.recurring') }
					]}
					onChange={onRecurringFilterChange}
				/>
			) : null}
			<ButtonSelect
				size="sm"
				value={activeFilter}
				options={[
					{ value: 'all' as const, title: T('default.all') },
					{ value: 'active' as const, title: T('default.active') },
					{ value: 'inactive' as const, title: T('default.inactive') }
				]}
				onChange={onActiveFilterChange}
			/>
		</Flex>
	);
};

export default ProductListFilters;
